{
  "login": {
    "title": "Sign in to your account",
    "subtitle": "Please enter your credentials to continue",
    "email": "Email Address",
    "password": "Password",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "signIn": "Sign In",
    "forgotPassword": "Forgot your password?",
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 6 characters long"
    }
  },
  "forgotPassword": {
    "title": "Reset your password",
    "subtitle": "Enter your email address and we'll send you a reset link",
    "email": "Email Address",
    "emailPlaceholder": "Enter your email address",
    "sendReset": "Send Reset Link",
    "backToLogin": "Back to Sign In",
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address"
    }
  },
  "home": {
    "appName": "Mosaic Dashboard",
    "toggleMenu": "Toggle menu",
    "navigation": "Navigation"
  },
  "navigation": {
    "projectInsights": "Project Insights",
    "myProjects": "My Projects"
  },
  "projectInsight": {
    "title": "{{name}} - Insights",
    "titleError": "Project Insights",
    "subtitle": "View detailed analytics and performance metrics for this project",
    "emptyState": "Project insights dashboard will be implemented here",
    "comingSoon": "Insights and analytics coming soon...",
    "countdown": {
      "privateSaleStartsIn": "Private Sale Starts In",
      "privateSaleEndsIn": "Private Sale Ends In",
      "publicSaleEndsIn": "Public Sale Ends In",
      "tgeIn": "TGE In",
      "saleEnded": "Sale Ended",
      "days": "DAYS",
      "hours": "HOURS",
      "minutes": "MINUTES",
      "seconds": "SECONDS"
    },
    "progress": {
      "softCap": "Soft Cap",
      "hardCap": "Hard cap"
    },
    "raisedAmounts": {
      "totalRaisedPrivate": "Total raised in private sale",
      "totalRaisedPublic": "Total raised in public sale",
      "totalRaised": "Total raised",
      "contributors": "contributors",
      "viewContributors": "View contributors",
      "exportList": "Export contributor list"
    },
    "investmentRounds": {
      "title": "Investment Rounds",
      "tooltip": "Token sale stages with different prices.",
      "privateSale": "Private Sale",
      "publicSale": "Public Sale",
      "tgeDate": "TGE Date",
      "live": "LIVE"
    },
    "contributorsModal": {
      "title": "Top Contributors",
      "subtitle": "Showing top contributors (Total: {{count}})",
      "table": {
        "rank": "Rank",
        "walletAddress": "Wallet Address",
        "contributedAmount": "Contributed Amount"
      },
      "tooltips": {
        "copyAddress": "Copy address",
        "viewOnExplorer": "View on explorer"
      },
      "exportList": "Export contributor list",
      "noDataToExport": "No contributors to export",
      "exportSuccess": "Contributors list exported successfully",
      "loadError": "Failed to load contributors. Please try again.",
      "noContributors": "No contributors found"
    }
  },
  "common": {
    "ok": "OK",
    "goBack": "Go Back",
    "logout": "Logout",
    "copied": "Copied",
    "copiedToClipboard": "Address copied to clipboard",
    "cancel": "Cancel",
    "save": "Save",
    "update": "Update",
    "create": "Create",
    "delete": "Delete",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "feature": "Feature",
    "unfeature": "Unfeature",
    "unsaved": "Unsaved",
    "saving": "Saving",
    "savedAt": "Saved",
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Info",
    "noChangesToSave": "All changes have been saved"
  },
  "validation": {
    "required": "This field is required"
  },
  "errors": {
    "title": "Error",
    "warning": "Warning",
    "info": "Information",
    "unknown": "An unexpected error occurred. Please try again.",
    "network": "Network error. Please check your internet connection.",
    "server": "Server error. Please try again later.",
    "unauthorized": "You are not authorized. Please log in.",
    "forbidden": "You don't have permission to perform this action.",
    "validation.permission-denied": "Permission denied.",
    "validation.invalid-token": "Invalid authentication token.",
    "validation.invalid-credentials": "Invalid email or password.",
    "validation.invalid-activation-data": "Invalid activation data.",
    "validation.insufficient-permissions": "Insufficient permissions.",
    "validation.unauthenticated": "You must be logged in to perform this action.",
    "validation.user-not-found": "User not found. Please check your credentials.",
    "validation.user-already-activated": "This account is already activated.",
    "validation.email-already-exists": "This email is already registered.",
    "validation.username-already-exists": "This username is already taken.",
    "validation.missing-required-fields": "Missing required fields.",
    "validation.password-change-code-expired": "Password reset code has expired.",
    "validation.google-verification-failed": "Google verification failed.",
    "validation.google-client-id-not-configured": "Google OAuth is not configured.",
    "validation.api-token-not-found": "Authentication token not found.",
    "validation.login-not-found": "Login session not found.",
    "validation.invalid-role": "Invalid role specified."
  },
  "projects": {
    "title": "My Projects",
    "subtitle": "Manage your projects",
    "addProject": "Add Project",
    "editProject": "Edit Project",
    "addProjectSubtitle": "Create a new project with detailed configuration",
    "editProjectSubtitle": "Update project information and settings",
    "searchPlaceholder": "Search projects...",
    "noData": "No projects found",
    "headers": {
      "name": "Name",
      "actions": "Actions"
    },
    "edit": "Edit project",
    "delete": "Delete project",
    "refresh": "Refresh projects list",
    "confirmDelete": {
      "header": "Confirm Delete",
      "message": "Are you sure you want to delete project \"{{name}}\"?",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "success": {
      "deleteTitle": "Project Deleted",
      "deleteMessage": "Project \"{{name}}\" has been successfully deleted."
    }
  },
  "projectEdit": {
    "addTitle": "Add Project",
    "editTitle": "Edit Project",
    "addProjectSubtitle": "Create a new project with detailed configuration",
    "editSubtitle": "Update project information and settings",
    "projectInformation": "Project Information",
    "additionalContent": "Additional Content",
    "projectOverview": {
      "title": "Project Overview",
      "description": "Provide a detailed description of your project",
      "placeholder": "Enter a comprehensive overview of your project, including its goals, features, and benefits..."
    },
    "projectName": "Project Name",
    "ownerName": "Owner Name",
    "ownerUrl": "Project Website",
    "description": "Description",
    "categories": "Categories",
    "categoriesPlaceholder": "Select categories",
    "categoriesRequired": "At least one category is required",
    "location": "Location",
    "followOn": "Follow on:",
    "documentation": "Documentation:",
    "tokenInformation": "Token Information",
    "usdt": "USDT",
    "dash": "–",
    "tokenName": "Name",
    "tokenSymbol": "Symbol",
    "tokenAddress": "Address",
    "totalSupply": "Total Supply",
    "swapOn": "Swap On",
    "claimOn": "Claim On",
    "publicSalePriceSupply": "Public Sale Price Supply",
    "privateSalePriceSupply": "Private Sale Price Supply",
    "saleInformation": "Sale Information",
    "softCap": "SoftCap",
    "hardCap": "HardCap",
    "minMaxAllocation": "Min/Max Allocation",
    "totalTokensForSale": "Total Tokens for Sale",
    "poolTypes": "Pool Types",
    "unsoldTokens": "Unsold Tokens",
    "investmentRounds": "Investment Rounds",
    "autoLinkDates": "Use consecutive period dates",
    "autoLinkDatesTooltip": "When enabled, each period's end date is automatically set to the start of the next period. Private Sale ends at Public Sale start, Public Sale ends at TGE.",
    "privateSale": "Private Sale",
    "publicSale": "Public Sale",
    "tgeDate": "TGE Date",
    "oneUsdtEquals": "1 USDT =",
    "tgeDateAndTime": "TGE Date & Time",
    "startDateAndTime": "Start Date & Time",
    "endDateAndTime": "End Date & Time",
    "selectStartDate": "Select start date",
    "selectEndDate": "Select end date",
    "selectTgeDate": "Select TGE date",
    "imageUploaded": "Image uploaded successfully",
    "imageUploadError": "Failed to upload image. Please try again.",
    "changeImage": "Change",
    "uploadImageButton": "Upload",
    "name": "Project Name",
    "namePlaceholder": "Enter project name",
    "subtitle": "Project Subtitle",
    "subtitlePlaceholder": "Enter project subtitle",
    "exchangeRate": "Exchange Rate (USD)",
    "exchangeRatePlaceholder": "Enter exchange rate",
    "privateInvestmentStart": "Private Investment Start",
    "privateInvestmentStartPlaceholder": "Select date and time",
    "publicInvestmentStart": "Public Investment Start",
    "publicInvestmentStartPlaceholder": "Select date and time",
    "investmentEnds": "Investment Ends",
    "investmentEndsPlaceholder": "Select date and time",
    "fileUpload": "Project Images",
    "chooseFiles": "Choose Files",
    "uploadFiles": "Upload",
    "clearFiles": "Clear",
    "cancelUpload": "Cancel",
    "dragDropFiles": "Drag and drop files here or click to browse",
    "supportedFormats": "Supported formats: JPG, PNG, GIF (Max 10MB per file)",
    "filesSelected": "files selected",
    "addMore": "Add More",
    "clearAll": "Clear All",
    "noImagesYet": "No images added yet",
    "addImagesDescription": "Add images to showcase your project",
    "pendingFiles": "Pending Files",
    "uploadedFiles": "Uploaded Files",
    "imagePreview": "Image Preview",
    "selectedImages": "Selected Images",
    "deleteFile": "Delete file",
    "noImagesSelected": "No Images Selected",
    "noImagesDescription": "Upload images to showcase your project",
    "fileUploadSuccess": "Upload Success",
    "filesUploaded": "Files have been uploaded successfully",
    "save": "Save Changes",
    "saving": "Saving...",
    "create": "Create Project",
    "creating": "Creating...",
    "cancel": "Cancel",
    "next": "Next",
    "back": "Back",
    "projectNamePlaceholder": "Project name",
    "ownerNamePlaceholder": "Enter owner name",
    "ownerNameRequired": "Owner name is required",
    "ownerPlaceholder": "Owner URL",
    "ownerUrlRequired": "Owner website URL is required",
    "descriptionPlaceholder": "Project description",
    "locationPlaceholder": "Select a country",
    "locationFilterPlaceholder": "Search countries",
    "tokenNamePlaceholder": "Token name",
    "tokenSymbolPlaceholder": "Token symbol",
    "tokenAddressPlaceholder": "Token address",
    "totalSupplyPlaceholder": "Total supply",
    "swapOnPlaceholder": "Select blockchain",
    "swapOnFilterPlaceholder": "Search blockchains",
    "claimOnPlaceholder": "Platform",
    "publicSalePricePlaceholder": "Price per token",
    "privateSalePricePlaceholder": "Price per token",
    "softCapPlaceholder": "Soft cap amount",
    "hardCapPlaceholder": "Hard cap amount",
    "minAllocationPlaceholder": "Min",
    "maxAllocationPlaceholder": "Max",
    "totalTokensForSalePlaceholder": "Total tokens",
    "poolTypesPlaceholder": "Pool types description",
    "unsoldTokensPlaceholder": "Unsold tokens policy",
    "tgePricePlaceholder": "TGE price",
    "nameRequired": "Project name is required",
    "descriptionRequired": "Project description is required",
    "descriptionMaxLength": "Project description cannot exceed 600 characters",
    "socialLinks": "Social Links",
    "twitterPlaceholder": "Twitter URL",
    "linkedinPlaceholder": "LinkedIn URL",
    "telegramPlaceholder": "Telegram URL",
    "discordPlaceholder": "Discord URL",
    "whitepaperPlaceholder": "Whitepaper URL",
    "tokenomicsPlaceholder": "Tokenomics URL",
    "invalidUrl": "Please enter a valid URL",
    "imageTooLarge": "Image file is too large (max 5MB)",
    "invalidImageType": "Please select a valid image file (PNG, JPG, JPEG, WebP, GIF)",
    "requiredField": "{{field}} is required",
    "minLengthError": "{{field}} must be at least {{min}} characters long",
    "maxLengthError": "{{field}} cannot exceed {{max}} characters",
    "minValueError": "{{field}} must be at least {{min}}",
    "invalidFormat": "{{field}} has an invalid format",
    "invalidField": "{{field}} is invalid",
    "tokenNameRequired": "Token name is required",
    "tokenSymbolRequired": "Token symbol is required",
    "tokenAddressRequired": "Token address is required",
    "totalSupplyRequired": "Total supply is required",
    "swapOnRequired": "Swap platform is required",
    "claimOnRequired": "Claim platform is required",
    "publicSalePriceRequired": "Public sale price is required",
    "privateSalePriceRequired": "Private sale price is required",
    "softCapRequired": "Soft cap is required",
    "hardCapRequired": "Hard cap is required",
    "minAllocationRequired": "Minimum allocation is required",
    "maxAllocationRequired": "Maximum allocation is required",
    "totalTokensForSaleRequired": "Total tokens for sale is required",
    "poolTypesRequired": "Pool types is required",
    "unsoldTokensRequired": "Unsold tokens policy is required",
    "privateSaleStartRequired": "Private sale start date is required",
    "privateSaleEndRequired": "Private sale end date is required",
    "publicSaleStartRequired": "Public sale start date is required",
    "publicSaleEndRequired": "Public sale end date is required",
    "tgeDateRequired": "TGE date is required",
    "tgePriceRequired": "TGE price is required",
    "roadmap": {
      "title": "Project Roadmap",
      "image": "Roadmap Image",
      "chooseImage": "Choose Image",
      "removeImage": "Remove image",
      "url": "Roadmap URL",
      "urlPlaceholder": "Enter roadmap link (e.g., https://example.com/roadmap)"
    },
    "tokenomics": {
      "title": "Project Tokenomics",
      "image": "Tokenomics Image",
      "chooseImage": "Choose Image",
      "removeImage": "Remove image",
      "url": "Tokenomics URL",
      "urlPlaceholder": "Enter tokenomics link (e.g., https://example.com/tokenomics)"
    },
    "teamMembers": {
      "title": "Team Members",
      "addMember": "Add Member",
      "editMember": "Edit Member",
      "updateMember": "Update Member",
      "removeMember": "Remove Member",
      "addFirstMember": "Add First Member",
      "noMembers": "No Team Members Yet",
      "noMembersDescription": "Start building your team by adding your first team member",
      "image": "Profile Image",
      "chooseImage": "Choose Image",
      "removeImage": "Remove image",
      "name": "Full Name",
      "namePlaceholder": "Enter full name",
      "position": "Position/Title",
      "positionPlaceholder": "Enter position or job title",
      "linkedinUrl": "LinkedIn Profile",
      "linkedinUrlPlaceholder": "Enter LinkedIn profile URL",
      "description": "Description",
      "descriptionPlaceholder": "Enter a brief description about this team member",
      "viewLinkedIn": "View LinkedIn",
      "addSuccess": "Team member \"{{name}}\" added successfully",
      "updateSuccess": "Team member \"{{name}}\" updated successfully",
      "removeSuccess": "Team member \"{{name}}\" removed successfully"
    },
    "tokenAllocation": {
      "title": "Token Allocation",
      "tokenSupply": "Token Supply",
      "privateSale": "Private Sale",
      "publicSale": "Public Sale",
      "allocations": "Allocations",
      "addAllocation": "Add Allocation",
      "editAllocation": "Edit Allocation",
      "updateAllocation": "Update Allocation",
      "removeAllocation": "Remove Allocation",
      "name": "Allocation Name",
      "namePlaceholder": "Allocation name",
      "color": "Color",
      "percentage": "Percentage",
      "emptyMessage": "No allocations added yet. Click 'Add Allocation' to get started.",
      "total": "Total",
      "addSuccess": "Token allocation \"{{name}}\" added successfully",
      "updateSuccess": "Token allocation \"{{name}}\" updated successfully",
      "removeSuccess": "Token allocation \"{{name}}\" removed successfully"
    },
    "vestingCategories": {
      "title": "Vesting Categories",
      "addButton": "Add Category",
      "addCategory": "Add Vesting Category",
      "editCategory": "Edit Vesting Category",
      "updateCategory": "Update Category",
      "editTitle": "Edit Vesting Category",
      "addTitle": "Add Vesting Category",
      "category": "Category",
      "categoryLabel": "Category",
      "categoryPlaceholder": "Enter category name",
      "walletAddress": "Wallet Address",
      "walletAddressPlaceholder": "0x...",
      "walletAddressRequired": "Wallet address is required",
      "walletAddressInvalid": "Please enter a valid Ethereum wallet address (0x...)",
      "cliffPeriod": "Cliff Period",
      "cliffPeriodLabel": "Cliff period (months)",
      "cliffPeriodPlaceholder": "Enter number of months (minimum 1)",
      "vestingPeriod": "Vesting Period",
      "vestingPeriodLabel": "Vesting Period",
      "vestingPeriodPlaceholder": "Enter vesting period in months",
      "vestingDuration": "Vesting Duration",
      "vestingDurationLabel": "Vesting duration (months)",
      "vestingDurationPlaceholder": "Enter number of months (minimum 1)",
      "releasingFrequency": "Releasing Frequency",
      "releasingFrequencyLabel": "Releasing Frequency",
      "releasingFrequencyPlaceholder": "Enter releasing frequency",
      "initialUnlock": "Initial Unlock",
      "initialUnlockLabel": "Initial Unlock",
      "initialUnlockPlaceholder": "Enter initial unlock percentage",
      "tgeUnlock": "TGE Unlock %",
      "tgeUnlockLabel": "TGE Unlock %",
      "tgeUnlockPlaceholder": "Enter TGE unlock percentage",
      "firstClaim": "First claim available (months after TGE)",
      "firstClaimLabel": "First claim available (months after TGE)",
      "firstClaimPlaceholder": "Enter number of months after TGE",
      "firstClaimRequired": "First claim timing is required",
      "firstClaimMin": "First claim value must be 0 or greater",
      "months": "months",
      "emptyMessage": "No vesting categories added yet. Click 'Add Category' to get started.",
      "addSuccess": "Vesting category \"{{category}}\" added successfully",
      "updateSuccess": "Vesting category \"{{category}}\" updated successfully",
      "removeSuccess": "Vesting category \"{{category}}\" removed successfully"
    },
    "updates": {
      "title": "Updates",
      "addUpdate": "Add Update",
      "editUpdate": "Edit Update",
      "updateUpdate": "Update",
      "removeUpdate": "Remove Update",
      "addFirstUpdate": "Add First Update",
      "noUpdates": "No Updates Yet",
      "noUpdatesDescription": "Keep your community informed by adding project updates",
      "coverImage": "Cover Image",
      "chooseCoverImage": "Choose Cover Image",
      "removeCoverImage": "Remove cover image",
      "updateTitle": "Title",
      "titlePlaceholder": "Enter update title",
      "text": "Content",
      "textPlaceholder": "Enter update content",
      "publishDate": "Publish Date",
      "publishDatePlaceholder": "Select publish date",
      "addSuccess": "Update \"{{title}}\" added successfully",
      "updateSuccess": "Update \"{{title}}\" updated successfully",
      "removeSuccess": "Update \"{{title}}\" removed successfully"
    },
    "actions": "Actions",
    "edit": "Edit",
    "remove": "Remove",
    "errors": {
      "nameRequired": "Project name is required",
      "nameMinLength": "Project name must be at least 3 characters long",
      "nameMaxLength": "Project name cannot exceed 30 characters",
      "subtitleRequired": "Project subtitle is required",
      "subtitleMinLength": "Project subtitle must be at least 3 characters long",
      "exchangeRateRequired": "Exchange rate is required",
      "exchangeRateMin": "Exchange rate must be greater than 0",
      "privateInvestmentStartRequired": "Private investment start date is required",
      "publicInvestmentStartRequired": "Public investment start date is required",
      "investmentEndsRequired": "Investment end date is required",
      "roadmapUrlInvalid": "Please enter a valid URL (must start with http:// or https://)",
      "tokenomicsUrlInvalid": "Please enter a valid URL (must start with http:// or https://)",
      "teamMemberImageRequired": "Team member image is required",
      "teamMemberNameRequired": "Team member name is required",
      "teamMemberNameMinLength": "Name must be at least 2 characters long",
      "teamMemberPositionRequired": "Position is required",
      "teamMemberPositionMinLength": "Position must be at least 2 characters long",
      "teamMemberLinkedinUrlRequired": "LinkedIn URL is required",
      "teamMemberLinkedinUrlInvalid": "Please enter a valid LinkedIn URL",
      "teamMemberDescriptionRequired": "Description is required",
      "teamMemberDescriptionMinLength": "Description must be at least 10 characters long",
      "vestingCategoryRequired": "Vesting category name is required",
      "vestingCategoryMinLength": "Category name must be at least 2 characters long",
      "cliffPeriodRequired": "Cliff period is required",
      "cliffPeriodMin": "Cliff period must be at least 1 month",
      "vestingDurationRequired": "Vesting duration is required",
      "vestingDurationMin": "Vesting duration must be at least 1 month",
      "vestingPeriodRequired": "Vesting period is required",
      "vestingPeriodMin": "Vesting period must be greater than 0",
      "releasingFrequencyRequired": "Releasing frequency is required",
      "releasingFrequencyMinLength": "Releasing frequency must be at least 2 characters long",
      "initialUnlockRequired": "Initial unlock percentage is required",
      "initialUnlockMin": "Initial unlock must be 0 or greater",
      "initialUnlockMax": "Initial unlock cannot exceed 100%",
      "updateTitleRequired": "Update title is required",
      "updateTitleMinLength": "Title must be at least 3 characters long",
      "updateTextRequired": "Update content is required",
      "updateTextMinLength": "Content must be at least 10 characters long",
      "updatePublishDateRequired": "Publish date is required",
      "locationRequired": "Location is required",
      "swapOnRequired": "Swap blockchain is required",
      "claimOnRequired": "Claim platform is required"
    },
    "success": {
      "imageUploadedTitle": "Image Uploaded",
      "imageUploadedMessage": "Project image has been successfully uploaded.",
      "editTitle": "Project Updated",
      "editMessage": "Project information has been successfully updated.",
      "createTitle": "Project Created",
      "createMessage": "New project has been successfully created.",
      "publishTitle": "Project Published",
      "publishMessage": "The project has been successfully published and is now visible to users.",
      "unpublishTitle": "Project Unpublished",
      "unpublishMessage": "The project has been unpublished and is now hidden from users.",
      "featureTitle": "Project Featured",
      "featureMessage": "The project has been featured and will display prominently on the homepage.",
      "unfeatureTitle": "Project Unfeatured",
      "unfeatureMessage": "The project has been removed from the featured section."
    },
    "saveInProgress": {
      "message": "A save is currently in progress. Are you sure you want to leave? Unsaved changes may be lost."
    },
    "autoSaveFailed": "Auto-save failed. Please check your connection and try again.",
    "status": {
      "label": "Status",
      "draft": "Draft",
      "pending_approval": "Pending Approval",
      "approved": "Approved",
      "rejected": "Rejected",
      "published": "Published",
      "pendingApprovalMessage": "This project is awaiting admin review. You cannot edit it until reviewed.",
      "rejectedMessage": "This project was rejected. You can edit and resubmit it.",
      "approvedMessage": "This project has been approved! Admin will publish it soon."
    },
    "approval": {
      "submitForApproval": "Submit for Approval",
      "confirmSubmit": "Are you sure you want to submit this project for approval? You won't be able to edit it until it's reviewed.",
      "saveBeforeSubmit": "Please save all changes before submitting for approval.",
      "submitSuccess": "Submitted Successfully",
      "submitSuccessMessage": "Your project has been submitted for admin review. You'll be notified once it's reviewed.",
      "missingFields": "Please complete the following required fields"
    }
  },
  "investmentTier": {
    "addTitle": "Add Investment Tier",
    "editTitle": "Edit Investment Tier",
    "addSubtitle": "Create a new investment tier for your project",
    "editSubtitle": "Update investment tier information",
    "title": "Tier Title",
    "titlePlaceholder": "Enter tier title (e.g., Bronze Supporter - 100 USDT)",
    "usdtPrice": "USDT Price",
    "usdtPricePlaceholder": "Enter price in USDT",
    "eurPrice": "EUR Price",
    "eurPricePlaceholder": "Enter equivalent price in EUR",
    "bonusText": "Bonus Text",
    "bonusTextPlaceholder": "Enter bonus description (e.g., +2% bonus tokens)",
    "tokenAmount": "Token Amount",
    "tokenAmountPlaceholder": "Enter number of tokens",
    "save": "Save Changes",
    "create": "Create Tier",
    "cancel": "Cancel",
    "editTier": "Edit Tier",
    "removeTier": "Remove Tier",
    "errors": {
      "titleRequired": "Tier title is required",
      "titleMinLength": "Title must be at least 3 characters long",
      "usdtPriceRequired": "USDT price is required",
      "usdtPriceMin": "USDT price must be greater than 0",
      "eurPriceRequired": "EUR price is required",
      "eurPriceMin": "EUR price must be greater than 0",
      "bonusTextRequired": "Bonus text is required",
      "bonusTextMinLength": "Bonus text must be at least 3 characters long",
      "tokenAmountRequired": "Token amount is required",
      "tokenAmountMin": "Token amount must be at least 1"
    }
  }
}
